import { useLocation } from "preact-iso";
import { useEffect, useState } from "preact/hooks";
import { apiClient } from "../../constants.ts";
import { usePageMeta } from "./pageMeta.ts";

export const Unsubscribe = () => {
  usePageMeta({
    title: "Unsubscribe | prompt2bot",
    description: "Unsubscribe from prompt2bot notifications.",
  });
  const { url } = useLocation();
  const [status, setStatus] = useState<"loading" | "success" | "error">(
    "loading",
  );

  useEffect(() => {
    const parts = url.split("/unsubscribe/")[1]?.split("/");
    const userId = parts?.[0];
    const token = parts?.[1];

    if (!userId || !token) {
      setStatus("error");
      return;
    }

    apiClient({
      endpoint: "unsubscribe-newsletter",
      payload: { userId, token },
    })
      .then((res) => {
        if (res.success) {
          setStatus("success");
        } else {
          setStatus("error");
        }
      })
      .catch(() => setStatus("error"));
  }, [url]);

  return (
    <div className="container mx-auto px-4 py-8 flex items-center justify-center min-h-screen">
      <div className="bg-surface-raised-light dark:bg-surface-raised rounded-lg shadow-md p-8 max-w-md text-center">
        {status === "loading" && (
          <>
            <h1 className="text-2xl font-bold mb-4">Unsubscribing...</h1>
            <p>Please wait while we process your request.</p>
          </>
        )}
        {status === "success" && (
          <>
            <h1 className="text-2xl font-bold mb-4 text-green-600">
              Successfully Unsubscribed
            </h1>
            <p className="mb-4">
              You have been unsubscribed from the prompt2bot newsletter.
            </p>
            <p className="text-sm text-text-secondary-light dark:text-text-secondary">
              You can update your preferences at any time in your{" "}
              <a
                href="/settings"
                className="text-accent-light dark:text-accent hover:underline"
              >
                settings
              </a>
              .
            </p>
          </>
        )}
        {status === "error" && (
          <>
            <h1 className="text-2xl font-bold mb-4 text-danger">Error</h1>
            <p>
              We couldn't process your unsubscribe request. Please try again or
              contact support.
            </p>
          </>
        )}
      </div>
    </div>
  );
};
